import localforage from 'localforage'

localforage.config({
  driver: localforage.INDEXEDDB,
  name: 'Redak',
  version: 1.0,
  storeName: 'keyvaluepairs',
  description: 'IndexedDB for Redak'
})
